import { usePartner } from 'components/app/routes/usePartner';

type RevampJourneyHook = {
  isRevampJourney: boolean;
};

export const useRevampJourney = (): RevampJourneyHook => {
  const { isDSJourney } = usePartner();

  return {
    isRevampJourney: isDSJourney
  };
};
